(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["designeria-consent-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-dg-consent]');
    if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    const show = () => { banner.hidden = false; };
    const hide = () => { banner.hidden = true; };
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      const privacy = window.Shopify.customerPrivacy;
      const consent = typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      const consentRecorded = consent && ['analytics', 'marketing', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');
      if (privacy.shouldShowBanner() && !consentRecorded) show();
      const apply = (consent) => privacy.setTrackingConsent(consent, hide);
      banner.querySelector('[data-dg-consent-all]').addEventListener('click', () => apply({ analytics: true, marketing: true, preferences: true }));
      banner.querySelector('[data-dg-consent-essential]').addEventListener('click', () => apply({ analytics: false, marketing: false, preferences: false }));
      const customize = banner.querySelector('[data-dg-consent-customize]');
      const panel = banner.querySelector('#dg-consent-preferences');
      customize.addEventListener('click', () => {
        const expanded = customize.getAttribute('aria-expanded') === 'true';
        customize.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
      banner.querySelector('[data-dg-consent-save]').addEventListener('click', () => apply({
        analytics: banner.querySelector('[data-dg-consent-analytics]').checked,
        marketing: banner.querySelector('[data-dg-consent-marketing]').checked,
        preferences: banner.querySelector('[data-dg-consent-preferences]').checked
      }));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["designeria-demo-light"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('dw-light-controller')) return;
  customElements.define('dw-light-controller', class extends HTMLElement {});
  const init = root => root.querySelectorAll('[data-dw-light]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const button = section.querySelector('[data-dw-light-switch]');
    const label = section.querySelector('[data-dw-light-label]');
    const state = section.querySelector('[data-dw-light-state]');
    section.querySelector('[data-dw-light-controls]').hidden = false;
    button.addEventListener('click', () => {
      const lit = section.dataset.lit !== 'true';
      section.dataset.lit = String(lit);
      button.setAttribute('aria-checked', String(lit));
      label.textContent = lit ? label.dataset.on : label.dataset.off;
      state.textContent = lit ? state.dataset.on : state.dataset.off;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["designeria-demo-room"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => root.querySelectorAll('[data-dw-room]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const controls = [...section.querySelectorAll('[data-dw-room-select]')];
    const panels = [...section.querySelectorAll('[data-dw-room-product]')];
    const select = id => {
      section.dataset.activeProduct = id;
      controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.dwRoomSelect === id)));
      panels.forEach(panel => {panel.hidden = panel.dataset.dwRoomProduct !== id;});
    };
    controls.forEach(control => control.addEventListener('click', () => select(control.dataset.dwRoomSelect)));
    if (panels[0]) select(panels[0].dataset.dwRoomProduct);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["designeria-demo-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => root.querySelectorAll('[data-dw-story]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const steps = [...section.querySelectorAll('[data-dw-story-step]')];
    const images = [...section.querySelectorAll('[data-dw-story-image]')];
    const links = [...section.querySelectorAll('[data-dw-story-link]')];
    let active = -1;
    let queued = false;
    let visible = false;
    const select = index => {
      if (active === index) return;
      active = index;
      section.dataset.activeStep = String(index);
      steps.forEach((step, i) => step.classList.toggle('is-current', i === index));
      images.forEach(image => {
        const current = Number(image.dataset.dwStoryImage) === index;
        image.classList.toggle('is-current', current);
        image.setAttribute('aria-hidden', String(!current));
      });
      links.forEach((link, i) => i === index ? link.setAttribute('aria-current', 'step') : link.removeAttribute('aria-current'));
    };
    const update = () => {
      queued = false;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const line = window.innerHeight * (mobile ? .78 : .52);
      let nearest = 0;
      let distance = Infinity;
      steps.forEach((step, index) => {
        const rect = step.getBoundingClientRect();
        const d = Math.abs((rect.top + rect.bottom) / 2 - line);
        if (d < distance) { nearest = index; distance = d; }
      });
      select(nearest);
    };
    const scroll = () => {
      if (!section.isConnected) { window.removeEventListener('scroll', scroll); return; }
      if (!visible || queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) update();
    });
    observer.observe(section);
    window.addEventListener('scroll', scroll, {passive:true});
    window.addEventListener('resize', scroll, {passive:true});
    links.forEach((link, index) => link.addEventListener('click', event => {
      event.preventDefault();
      select(index);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const rect = steps[index].getBoundingClientRect();
      const target = window.scrollY + (rect.top + rect.bottom) / 2 - window.innerHeight * (mobile ? .78 : .52);
      window.scrollTo({top:target,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }));
    select(0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["designeria-navigation"] && !Shopify.designMode) return;
  try {
    const dgDesktopMenu=window.matchMedia('(min-width:990px) and (hover:hover)');
const dgCloseBranch=item=>{item.open=false;item.querySelectorAll('details[open]').forEach(child=>{child.open=false;});};
const dgInitHoverMenus=root=>{
  root.querySelectorAll('.dg-nav .dg-branch,.dg-nav .dg-twig').forEach(item=>{
    if(item.dataset.dgHoverReady)return;
    item.dataset.dgHoverReady='true';
    item.addEventListener('pointerenter',()=>{if(dgDesktopMenu.matches)item.open=true;});
    item.addEventListener('pointerleave',()=>{if(dgDesktopMenu.matches)dgCloseBranch(item);});
  });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>dgInitHoverMenus(document));else dgInitHoverMenus(document);
document.addEventListener('shopify:section:load',event=>dgInitHoverMenus(event.target));
document.addEventListener('click',event=>{if(!event.target.closest('.dg-nav'))document.querySelectorAll('.dg-nav .dg-branch[open]').forEach(dgCloseBranch);const link=event.target.closest('.dg-mobile-menu nav a');if(link)link.closest('.dg-mobile-menu').open=false;});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const open=event.target.closest('details[open]');if(open){event.preventDefault();dgCloseBranch(open);open.querySelector('summary').focus();}});
document.addEventListener('toggle',event=>{const item=event.target;if(item.matches('.dg-nav .dg-branch[open]'))item.closest('.dg-nav').querySelectorAll('.dg-branch[open]').forEach(other=>{if(other!==item)dgCloseBranch(other);});},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["designeria-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('designeria-personalisation-loops')) {
  customElements.define('designeria-personalisation-loops', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.videos = Array.from(this.querySelectorAll('.dg-personal__video'));
      this.button = this.querySelector('.dg-personal__motion');
      if (!this.videos.length || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pausedByUser = this.motion.matches;
      this.visible = new Set();
      this.pending = new WeakSet();
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.pausedByUser = !this.pausedByUser;
        this.updatePlayback();
      }, options);
      this.motion.addEventListener('change', (event) => {
        this.pausedByUser = event.matches;
        if (event.matches) this.videos.forEach(video => video.parentElement.classList.remove('is-video-ready'));
        this.updatePlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.addEventListener('playing', () => video.parentElement.classList.add('is-video-ready'), options);
        video.addEventListener('error', () => {
          video.parentElement.classList.remove('is-video-ready');
          video.dataset.failed = 'true';
        }, options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.visible.add(entry.target);
            else this.visible.delete(entry.target);
          });
          this.updatePlayback();
        }, { threshold: 0.08 });
        this.videos.forEach(video => this.observer.observe(video));
      } else {
        this.videos.forEach(video => this.visible.add(video));
      }
      this.updatePlayback();
    }
    updatePlayback() {
      this.button.textContent = this.pausedByUser ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      this.videos.forEach(video => {
        const active = !this.pausedByUser && !document.hidden && this.visible.has(video) && video.dataset.failed !== 'true';
        video.autoplay = active;
        if (!active) {
          video.pause();
          return;
        }
        if (!video.paused || this.pending.has(video)) return;
        this.pending.add(video);
        video.play().catch(error => {
          if (error.name === 'NotAllowedError') {
            this.pausedByUser = true;
            this.updatePlayback();
          }
        }).finally(() => this.pending.delete(video));
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.videos?.forEach(video => video.pause());
      this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
